import { render } from "./EinstellungenView.vue?vue&type=template&id=ccde3996"
import script from "./EinstellungenView.vue?vue&type=script&lang=js"
export * from "./EinstellungenView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__